import React from 'react';

/**
 * Farbiger Status-Indikator.
 *
 * @param {'ok'|'busy'|'queued'|'error'|'idle'} tone
 */
export default function StatusPill({ tone = 'idle', label, title }) {
    return (
        <span className={`pill pill-${tone}`} title={title}>
            <span className="pill-dot" aria-hidden="true" />
            {label}
        </span>
    );
}
